import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export function useSiteData(siteId) {
  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSite = async () => {
      if (!siteId) {
        setLoading(false);
        return;
      }

      try {
        const siteRef = doc(db, 'sites', siteId);
        const siteSnap = await getDoc(siteRef);
        
        if (siteSnap.exists()) {
          setSite({
            id: siteSnap.id,
            ...siteSnap.data()
          });
        } else {
          setError('Site not found');
        }
      } catch (err) {
        console.error('Error loading site:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadSite();
  }, [siteId]);

  return {
    site,
    loading,
    error
  };
}
